<div class="dashboardWidget medium">
    <div class="dashboardWrapper missedWidget" *ngIf="viewModel$ | async as viewModel">
      <div class="missedWidgetWrapper">
        <app-one-number [loading]="viewModel.loading"
                        [value]="viewModel.totalMissedCount"
                        reportType="missed"></app-one-number>
      </div>
    </div>
</div>
